import { render, staticRenderFns } from "./ModalTemplate.vue?vue&type=template&id=a2fad6d4&scoped=true&lang=pug"
import script from "./ModalTemplate.vue?vue&type=script&lang=js"
export * from "./ModalTemplate.vue?vue&type=script&lang=js"
import style0 from "./ModalTemplate.vue?vue&type=style&index=0&id=a2fad6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fad6d4",
  null
  
)

export default component.exports